import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class TopicMappingService {
  public topicAdded = new Subject();
  public topicContentAdded = new BehaviorSubject(null);

  constructor(private http: HttpClient) { }  
  node: Array<any> = [];
  //Add generic content to topic
  addMappedTopicGenericContent(agent_id,param){
    return this.http.post(environment.multi_topic_api+  agent_id + '/add_node' ,param)
  }

  //To get mappedtopics list in topic tab
  getMappedTopics(agentId,topic_uri){
    return this.http.get(environment.multi_topic_api +  agentId +'/'+topic_uri+ '/attached_topics')
  }

  //To get topic list
  get_all_nodes(agentId, topic_uri, feature_uri) {
    let uri: any;
    if (feature_uri == undefined || feature_uri == "") {
      uri = environment.multi_topic_api + agentId + '/' + topic_uri + '/get_all_nodes/';
    } else {
      uri = environment.multi_topic_api + agentId + '/' + topic_uri + '/' + feature_uri + '/get_all_nodes/';
    }
    return this.http.get(uri).pipe(
      map((response: Array<Object>) => {
        this.node = response;
        return response;
      })
    );
  }

  //Get generic content for indirect topic
  getGenericContentofIndirectTopic(agentId,topic_uri,feature_uri,attached_topic_uri){
    return this.http.get(environment.multi_topic_api +  agentId +'/'+topic_uri+'/'+feature_uri+'/'+attached_topic_uri+ '/feature_topic_data')
  }
  
    //To get mappedtopics list in feature tab
    getMappedTopicsUnderFeature(agentId,topic_uri,feature_uri){
        return this.http.get(environment.multi_topic_api +  agentId +'/'+topic_uri+'/'+feature_uri+ '/attached_topics')
      }
      
    
  //Add profile to feature
  addFeatureProfile(agent_id,param){
    return this.http.post(environment.profile_service_api+  agent_id + '/profile_content' ,param)
  }

  //Delete Topics
  deleteTopic(agent_id,mapped_topic_uri){
    return this.http.delete(environment.multi_topic_api + agent_id +'/'+mapped_topic_uri+'/delete_multitopic_mapping')
  }
 //Delete Topics
 deleteTopicMappedUnderFeature(agent_id,topic_uri,feature_uri,attached_topic_uri){

  let url:any;
  if(attached_topic_uri != undefined && attached_topic_uri != ""){
    url = environment.multi_topic_api + agent_id +'/'+topic_uri+"/"+feature_uri+"/"+attached_topic_uri+'/delete_node';
  }
  else{
    url = environment.multi_topic_api + agent_id +'/'+topic_uri+"/"+feature_uri+'/delete_node';
  }
  return this.http.delete(url)
}



  //Createtopic mapping
  createMultiTopicMapping(agentId,params) {
    return this.http.post(environment.multi_topic_api +  agentId + '/create_multitopic_mapping', params)
  }

  fetchTopicFeatureAssociations(agent_id, topic_uri) {
    let uri: any = environment.multi_topic_api + agent_id + '/' + topic_uri + '/get_topic_associations';
    return this.http.get(uri).pipe(
      map((response: any) => {
        this.node = response;
        return response;
      })
    );
  }


  fetchTopicAssociations(agent_id, topic_uri) {
    let uri: any = environment.multi_topic_api + agent_id + '/' + topic_uri + '/get_linked_nodes';
    return this.http.get(uri).pipe(
      map((response: any) => {
        this.node = response;
        return response;
      })
    );
  }

  

  
}
